export const EXTENSION_OVERLAY_REMOVAL_LIST_FF =
	'confluence.frontend.extension-overlay-removal-list';
